import type {
  ProposalDetail,
  ProposedAction,
} from '../../lib/proposals/core/types';
import { isSameLogicalAction } from '../../lib/proposals/utils/helpers';

/** Actions that render their own chrome — no accordion shell needed. */
export function rendersOwnChrome(action: ProposedAction): boolean {
  return (
    action.proposed_action_type_name === 'onboarding_action' ||
    action.proposed_action_type_name === 'create_pipeline'
  );
}

/**
 * Helper function to merge updated action back into full proposal
 */
export function mergeActionUpdate(
  proposal: ProposalDetail,
  updatedAction: ProposedAction
): ProposalDetail {
  return {
    ...proposal,
    actions: proposal.actions.map(a =>
      isSameLogicalAction(a, updatedAction) ? updatedAction : a
    ),
  };
}
